import Vue from 'vue'

export default function saveTeachers({ teachers }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/teachers"
    console.log(teachers, url)
    return Vue.http
        .post(url, teachers, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}